<template>
    <div>
        <br>
        <label>{{$t('createCampaign.logoUrl')}}</label>
        <div class="row">
            <div class="demiRow">
                <input type="text" v-model="couponPreview.imgUrl"/>
            </div>
            <p class="tips"> {{$t('createCampaign.showToCustomerAfterCreation')}}</p>
        </div>
        <div class="row alignStart">
            <div class="demiRow">
                <div class="column">
                    <div class="row">
                        <label>{{$t('createCampaign.backgroundColor')}}</label>
                        <p class="chip grey">{{$t('createCampaign.optional')}}</p>
                    </div>
                    <div class="row">
                        <input type="text" v-model="couponPreview.style.backgroundColor" class="smallInput" />
                        <p class="tips"> {{$t('createCampaign.leaveEmptyForWhite')}}</p>
                    </div>
                     <div class="row">
                        <label>{{$t('createCampaign.textColor')}}</label>
                        <p class="chip grey">{{$t('createCampaign.optional')}}</p>
                    </div>
                    <div class="row">
                        <input type="text" v-model="couponPreview.style.color" class="smallInput" />
                        <p class="tips"> {{$t('createCampaign.leaveEmptyForBlack')}}</p>
                    </div>
                </div>
            </div>
            <div class="demiRow">
                <div class="row alignCenter">
                    <div class="column couponPreview" :style="couponPreview.style">
                        <img :src="couponPreview.imgUrl"/>
                        <p  :style="{color:couponPreview.style.color}">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Mauris ipsum sapien, dictum id magna vitae, facilisis rutrum orci.  
                        </p>
                    </div>
                    <p class="tips">{{$t('createCampaign.preview')}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['couponPreview'],
 }
</script>